import { IRoundingHelper } from './IRoundingHelper';

export function notNaN(value: number, replacement: number): number {
    return isNaN(value) ? replacement : value;
}

export class RoundingHelper implements IRoundingHelper {
    // for backward compatibility
    static notNaN(value: number, replacement: number): number {
        return notNaN(value, replacement);
    }

    round(min: number, max: number): { min: number, max: number } {
        if (min === max) {
            if (min !== 0) {
                min = max / 10;
            } else {
                max = 1;
            }
        }
        const result = {
            min: min,
            max: max
        };
        const delta = max - min;
        const logDelta = Math.log(delta) / Math.LN10;
        const og = Math.pow(10, Math.floor(logDelta));
        result.min = Math.floor(min / og) * og;
        result.max = Math.ceil(max / og) * og;
        if (result.min === result.max) {
            if (result.min === 0) {
                result.max = 1;
            } else {
                result.min = result.max / 10;
            }
        }
        return result;
    }
}